<template>
  <div>
    <BlocMainTitle
      :title="$t('clients.clientInfo') "
    />

    <form>
      <ClientForm
        ref="mainForm"
        :populateWith="updatedData"
        @validChanged="isFormValid = $event"
        @sendData="onSendData"
      />
      <v-row
        align="center"
        justify="end"
        class="mr-1 pa-10"
      >
        <v-btn
          :disabled="!isFormValid || !isFormDirty"
          type="submit"
          color="secondary"
          @click.prevent="onClickUpdate"
        >
          {{ $t('forms.btn.save') }}
        </v-btn>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FormPageMixin from '@/mixins/FormPageMixin';
import ClientForm from '@/components/forms/ClientForm.vue';
import { cloneDeep } from 'lodash';
import BlocMainTitle from './BlocMainTitle.vue';

export default {
    components: {
        ClientForm,
        BlocMainTitle,
    },
    mixins: [
        FormPageMixin,
    ],
    data() {
        return {
            updatedData: null,
            isFormValid: false,
            isFormDirty: false,
            datas: null,
        };
    },
    computed: {
        ...mapGetters([
            'client',
            'hasPermission',
            'userLang',
            'teamMainLang',
        ]),
        defaultData() {
            return this.client;
        },
    },
    watch: {
        client: {
            async handler() {
                await this.getClientAccessGroups();
                // isActive: if the client is active from the BD
                this.updatedData = { ...this.client, isActive: this.client.active };
            },
        },
    },
    methods: {
        ...mapActions({
            reloadClient: 'getClientInfo',
            activePreventQuitFormular: 'activePreventQuitFormular',
            disablePreventQuitFormular: 'disablePreventQuitFormular',

        }),
        async onClickUpdate() {
            const { id: clientId, name, initialStatus, active: status } = this.updatedData;

            if (initialStatus) {
                const { clientAccessGroups } = this.updatedData;
                const { data } = await this.$rq.updateClientInfo(clientId, this.updatedData);
                if (data.id && clientAccessGroups && clientAccessGroups.length) {
                    await this.$rq.updateClientAccessGroup(data.id, { accessGroups: clientAccessGroups });
                }
                this.$toasted.global.toast_success({
                    message: this.$t('msg.clientModified', { data: data.name }),
                });
            }
            // Check if the current client status is diffrent from the initial status
            if (initialStatus !== status) {
                await this.$rq.updateClientStatus(clientId, { status });
                const { data: clientSites } = await this.$rq.getClientSites(clientId);
                if (this.hasPermission('sites.deactivate')) {
                    clientSites.sites.map(async site => { if (site.active !== status) { await this.$rq.updateSiteStatus(site.id, { status }); } });
                }
                this.$toasted.global.toast_success({
                    message: this.$t('msg.clientModified', { data: `${name}` }),
                });
            }
            await this.reloadClient(clientId);
        },
        onSendData(payload) {
            // We active the save button et the prevent formular if the formular is edited
            if (this.dataForm && payload !== this.data) {
                this.isFormDirty = true;
                this.activePreventQuitFormular();
            }

            this.dataForm = payload;

            const { address, city, country, postalCode, province, streetNumber } = this.dataForm || {};
            if (address && city && country && postalCode && province && streetNumber) {
                this.isFormValid = !!payload.isFormValid;
            }
            const data = cloneDeep(payload);
            delete data.isFormValid;
            this.updateData(data);
        },
        async getClientAccessGroups() {
            const { data: { accessGroups } } = await this.$rq.getClientAccessGroup(this.client.id);
            this.client.clientAccessGroups = accessGroups.map(({ id }) => id);
        },
    },
};
</script>

<style lang="scss" scoped>
  .blocTitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
</style>
